const ADMIN_KEY_STORAGE = 'scoutlytics_admin_key';

export function getAdminKey(): string | null {
  try {
    const value = sessionStorage.getItem(ADMIN_KEY_STORAGE);
    return value?.trim() ? value.trim() : null;
  } catch {
    return null;
  }
}

export function setAdminKey(key: string): void {
  sessionStorage.setItem(ADMIN_KEY_STORAGE, key.trim());
}

export function clearAdminKey(): void {
  sessionStorage.removeItem(ADMIN_KEY_STORAGE);
}

export function hasAdminKey(): boolean {
  return Boolean(getAdminKey());
}
